var productCardMarkup = 
  `<div id="swym-shared-wishlist-render-container"></div>
    <div class="swym-wishlist-grid">
		{{#products}} 
	<li href="{{du}}" aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor" data-id="{{epi}}">
        <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
          <span class="swym-icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close">
              <path d="M4.8745 11.7992L8 8.67367L11.1255 11.7992L11.7992 11.1255L8.67366 8L11.7992 4.8745L11.1255 4.20081L8 7.32633L4.8745 4.20081L4.20081 4.8745L7.32633 8L4.20081 11.1255L4.8745 11.7992ZM8.00141 16C6.90357 16 5.8692 15.79 4.89831 15.3701C3.92741 14.9502 3.07837 14.3768 2.35116 13.6499C1.62395 12.923 1.05028 12.0743 0.63017 11.1039C0.210057 10.1334 0 9.09924 0 8.00141C0 6.89494 0.209966 5.85491 0.629897 4.88132C1.04983 3.90772 1.62323 3.06082 2.35011 2.34064C3.077 1.62044 3.92568 1.05028 4.89614 0.63017C5.86661 0.210057 6.90076 0 7.99859 0C9.10506 0 10.1451 0.209965 11.1187 0.629896C12.0923 1.04983 12.9392 1.61972 13.6594 2.33959C14.3796 3.05946 14.9497 3.90598 15.3698 4.87915C15.7899 5.8523 16 6.89212 16 7.99859C16 9.09643 15.79 10.1308 15.3701 11.1017C14.9502 12.0726 14.3803 12.9216 13.6604 13.6488C12.9405 14.3761 12.094 14.9497 11.1209 15.3698C10.1477 15.7899 9.10788 16 8.00141 16ZM8 15.0445C9.96059 15.0445 11.6248 14.3584 12.9927 12.9862C14.3606 11.614 15.0445 9.95196 15.0445 8C15.0445 6.03941 14.3606 4.37516 12.9927 3.00727C11.6248 1.63939 9.96059 0.955455 8 0.955455C6.04804 0.955455 4.38596 1.63939 3.01376 3.00727C1.64156 4.37516 0.955455 6.03941 0.955455 8C0.955455 9.95196 1.64156 11.614 3.01376 12.9862C4.38596 14.3584 6.04804 15.0445 8 15.0445Z" fill="currentColor"></path>
            </svg>
          </span>
        </button>
        <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
          <div class="swym-wishlist-image-wrapper">
            <img alt="" class="swym-wishlist-image" src="{{iu}}">
          </div>
        </a>
        <button class="swym-is-button">
          <div class="swym-title swym-title-1">
              {{dt}}
          </div>
        </button>
		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
           <div class="swym-product-origional-price swym-value">
  		   </div>
        </div>
		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
			{{#isInCart}}Added to Bag{{/isInCart}}{{^isInCart}}Add to Bag{{/isInCart}}
		</button>
    </li> 
       {{/products}}
	</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist);

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {

		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
          p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
          p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
          p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");

          if (p.pr.split('.')[1] === '00') {
            p.pr = p.pr.split('.')[0];
          }

          fetch(p.du + ".json").then(response => response.json())
          .then(data => {
            data.product.variants.forEach(function(e) {
              console.log(data);
              var dataAttr = document.querySelector(`[data-id="${p.epi}"]`);

              var priceCompare = e.compare_at_price;
              if (priceCompare.split('.')[1] === '00') {
                priceCompare = priceCompare.split('.')[0];
              }

              if (dataAttr) {
                if (priceCompare !== '' && parseInt(priceCompare) <= 0) {
                  priceCompare = '';
                  dataAttr.querySelector('.swym-product-final-price').innerHTML = 'Preorder';
                } else {
                  priceCompare = p.cu + priceCompare;
                }
                
                if (priceCompare.replace('£', '')) {
                  console.log(priceCompare);
                  dataAttr.querySelector('.swym-product-origional-price').innerHTML = priceCompare;
                  dataAttr.querySelector('.swym-product-origional-price').style.textDecoration = 'line-through';
                  dataAttr.querySelector('.swym-product-final-price').style.color = '#cf0d2a';
                }
              }

            });
          });
          return p;
		});


      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
		
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function updateValue(e, action) {
  const wishlistElement = document.querySelectorAll('#wishlist-count span');
  let count = parseInt(wishlistElement[0].innerHTML);
  
  if(action == 'removed'){
   count -=1;   
  }
  else{
    count +=1;
  }

  wishlistElement[0].innerHTML = count;
}

//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  // Please make all SWYM-related API calls inside this function.
  // You can use the swat argument within this scope.
  
  //Define the event listener function
  let listener = function(e) { 
    var data = e.detail.d.productData;	
    console.log("YAY! Added the product to cart", data);

    //Reload the page after x seconds
    setTimeout(function(){
      window.location.reload();
    }, 1500);
  };

  // Add listener for the 'addedtocart' event to the Swym Event Layer
  swat.evtLayer.addEventListener('sw:addedtocart', listener);

  //Added to wishlist
  // swat.evtLayer.addEventListener('sw:addedtowishlist', function(e){
  //   updateValue(e, "added");
  // });

  // //Removed from wishlist
  // swat.evtLayer.addEventListener('sw:removedfromwishlist', function(e){
  //   updateValue(e, "removed");
  // });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

